module.exports = __webpack_public_path__ + "img/basement.916c9692.svg";